import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  gateway_states: [],
  gateway_state: {},
  gateway_list_view: {},
  gateway_revisions: [],
  gateway_revisions_view: {},
  profile_revisions: [],
  profile_revisions_view: {},
  spectral_scan: {},
  spectral_scan_view: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/modules/gatewayStates/store/index.js